// import React from "react";

// const TrustpilotWidget = () => (
//   <div
//     className="trustpilot-widget"
//     data-locale="en-US"
//     data-template-id="56278e9abfbbba0bdcd568bc"
//     data-businessunit-id="68a50737b0a2137d8b713ce2"
//     data-style-height="38px"
//     data-style-width="220px"
//     data-token="f71f596d-7ef4-432b-a4cc-c576489ae8a7"
//   >
//     <a
//       href="https://www.trustpilot.com/review/writerswaysolutions.com"
//       target="_blank"
//       rel="noopener noreferrer"
//     >
//       Trustpilot
//     </a>
//   </div>
// );

// export default TrustpilotWidget;

import React, { useEffect, useRef } from "react";

const TrustpilotWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    // Ensure Trustpilot script is loaded before calling
    const interval = setInterval(() => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(widgetRef.current, true);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      ref={widgetRef}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="56278e9abfbbba0bdcd568bc"
      data-businessunit-id="68a50737b0a2137d8b713ce2"
      data-style-height="38px"
      data-style-width="220px"
      data-token="f71f596d-7ef4-432b-a4cc-c576489ae8a7"
    >
      <a
        href="https://www.trustpilot.com/review/writerswaysolutions.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustpilotWidget;
